import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { CmsService } from 'src/app/core/services/cms.service';
import { CmsObject } from 'src/app/model/cmsobject';
import { Mode, SubscriptionToken } from 'src/app/model/subscription';
import { LoadingService } from 'src/app/core/services/loading.service';
import { LoginService } from 'src/app/core/services/login.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { OperationResult } from '@tb/auth';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { IndustryService } from 'src/app/industryeditor/pages/industries/industry.service';
import { ModelService } from 'src/app/core/services/model.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { InstancesService } from 'src/app/core/services/instances.service';
import { CuSubscriptionSlots } from 'src/app/model/TimeSlots';
import { IupService } from 'src/app/core/services/IupService';
import { MpIstance } from 'src/app/model/instance';
import { ProxyService } from 'src/app/core/services/proxy.service';
import { FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'ms-ranking-management',
    templateUrl: './ranking-management.component.html',
    styleUrls: ['./ranking-management.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class RankingManagementComponent implements OnInit {
    mng_ranking_title: string;
    mng_ranking_descri: string;
    mng_ranking_infoDbSize: string;
    mng_ranking_infoRanking: string;
    mng_ranking_infoRanking_2: string;
    language: string;
    message: string;
    search = '';
    searchInfo = '';
    editedDbSize = '';
    editedRanking = '';
    loading = false;
    panelOpenState = false;
    infoFound = false;
    noDataFound = false;
    existUserID = false;
    authorizationStored = this.loginService.getauthinfo();
    authorizationProperties: AuthorizationProperties = JSON.parse(this.authorizationStored);
    newInfo: NewInfo[];
    cmsObj: CmsObject[];
    expandedElement: NewInfo | null;
    rankings: Size[] = [
        { value: '0', viewValue: '0' },
        { value: '1', viewValue: '1' },
        { value: '2', viewValue: '2' },
        { value: '3', viewValue: '3' },
    ];
    rankingListAvailable: string[];
    dbSizeListAvailable: string[];
    nrCalAvailable: number[];
    countriesAvailable: string[];
    ranking: string;
    note: string = '';
    partnerCode = '';
    resellerCompanyName = '';
    userId = '';
    companyName = '';
    dataSource: MatTableDataSource<string>;
    dataSourceNewInfo: MatTableDataSource<NewInfo>;
    _paginatorSubscriptions: MatPaginator;
    //TODO: DA TRADURRE COLONNE
    displayedColumnsSubscriptions: string[] = ['Expand', 'Ranking', 'DbSize', 'NrCal', 'Country', 'SubscriptionKey', 'Description', 'Note'];
    filteredInstance: Array<string>;
    @ViewChild(MatSort) subscriptionsSort: MatSort;
    @ViewChild('subscriptionsPaginator') set paginatorSubscriptions(contentAccounts: MatPaginator) {
        if (contentAccounts) {
            this._paginatorSubscriptions = contentAccounts;
            const paginatorIntl = this._paginatorSubscriptions._intl;
            paginatorIntl.nextPageLabel = this.variable.nextPage;
            paginatorIntl.previousPageLabel = this.variable.previousPage;
            if (this.dataSourceNewInfo) {
                this.dataSourceNewInfo.paginator = this._paginatorSubscriptions;
            }
        }
    }

    constructor(
        private variable: TranslatedVariables,
        private loginService: LoginService,
        private loadingService: LoadingService,
        private cmsService: CmsService,
        private workFlow: WorkFlowService,
        public industryService: IndustryService,
        public modelService: ModelService,
        public instanceService: InstancesService,
        private iupService: IupService,
        private proxyService: ProxyService
    ) {
        this.dataSource = new MatTableDataSource<string>();
        this.dataSourceNewInfo = new MatTableDataSource<NewInfo>();
    }

    async ngOnInit() {
        await this.getCmsObj();
        await this.getInstancesByTags();
        const authorizationStored = this.loginService.getauthinfo();
        if (authorizationStored === null || authorizationStored === undefined) {
            //TODO: è abbastanza come messaggio di esito ?
            alert('User must be logged in.');
            return;
        }
        this.authorizationProperties = JSON.parse(authorizationStored);
    }

    async getCmsObj() {
        this.language = this.workFlow.getLanguageForCms();
        this.cmsObj = await this.cmsService.getCmsObj(this.language, 'rankingcomponent');
        this.mng_ranking_title = this.cmsObj.find((x) => x.ContentName == 'rankingcomponent.mng_ranking_title').ContentTranslation;
        this.mng_ranking_descri = this.cmsObj.find((x) => x.ContentName == 'rankingcomponent.mng_ranking_descri').ContentTranslation;
        this.mng_ranking_infoDbSize = this.cmsObj.find(
            (x) => x.ContentName == 'rankingcomponent.mng_ranking_infoDbSize'
        ).ContentTranslation;
        this.mng_ranking_infoRanking = this.cmsObj.find(
            (x) => x.ContentName == 'rankingcomponent.mng_ranking_infoRanking'
        ).ContentTranslation;
        this.mng_ranking_infoRanking_2 = this.cmsObj.find(
            (x) => x.ContentName == 'rankingcomponent.mng_ranking_infoRanking_2'
        ).ContentTranslation;
    }

    getDBSizeDescription(tempSize: string) {
        console.log('tempSize', tempSize);
        switch (tempSize) {
            case '0':
                return 'None';
            case '1':
                return 'Standard';
            case '2':
                return 'Large';
            case '3':
                return 'ExtraLarge';
            case '4':
                return 'Ultra';
            default:
                return '';
        }
    }

    getInstancesByTags() {
        this.loading = true;
        this.loadingService.setLoading(this.loading);
        this.instanceService.getInstancesbytags(Mode[Mode.rtm], this.authorizationProperties.accountName).subscribe(
            (opResult) => {
                if (!opResult.Result) {
                    this.loading = false;
                    this.loadingService.setLoading(this.loading);
                    this.workFlow.showMessage(this.variable.errorTitle, opResult.Message);
                    return;
                }
                let Istances = opResult.Content as MpIstance[];
                this.filteredInstance = Istances.filter((x) => x.InstanceKey !== null).map((x) => x.InstanceKey);
                this.dataSource.data = this.filteredInstance;
                this.loading = false;
                this.loadingService.setLoading(this.loading);
            },
            (err) => {
                this.loading = false;
                this.loadingService.setLoading(this.loading);
                this.workFlow.showMessage(this.variable.errorTitle, err.message);
            }
        );
    }

    applyFilter(event: any) {
        let filterValue: string;
        if (event.target) {
            filterValue = (event.target as HTMLInputElement).value;
        } else {
            filterValue = event;
        }
        this.dataSource.filteredData = this.dataSource.data.filter((name) => name.toLowerCase().includes(filterValue.trim().toLowerCase()));
        this.filteredInstance = this.dataSource.filteredData;
    }

    applyGenericFilter(event: any) {
        let filterValue;
        if (event.target) {
            filterValue = (event.target as HTMLInputElement).value;
        } else {
            filterValue = event;
        }
        this.dataSourceNewInfo.filter = filterValue;
        if (this.dataSourceNewInfo.paginator) {
            this.dataSourceNewInfo.paginator.firstPage();
        }
        if (this.dataSourceNewInfo.filteredData.length === 0) {
            this.noDataFound = true;
            this.infoFound = false;
        } else {
            this.noDataFound = false;
            this.infoFound = true;
        }
    }

    applyColumnFilter(column: string, value?: any) {
        switch (column) {
            case 'ranking':
                this.dataSourceNewInfo.data = this.newInfo.filter((x) => x.Ranking === value);
                return;
            case 'dbsize':
                this.dataSourceNewInfo.data = this.newInfo.filter((x) => x.DbSize === value);
                return;
            case 'nrCal':
                this.dataSourceNewInfo.data = this.newInfo.filter((x) => x.NrCal === value);
                return;
            case 'country':
                this.dataSourceNewInfo.data = this.newInfo.filter((x) => x.Country === value);
                return;
            case 'none':
                this.dataSourceNewInfo.data = this.newInfo;
                return;
        }
    }

    clearSearch() {
        this.search = '';
        this.dataSource.filteredData = this.dataSource.data;
        this.filteredInstance = this.dataSource.data;
        this.noDataFound = false;
        this.infoFound = true;
    }

    clearSearchInfo() {
        this.searchInfo = '';
        this.dataSourceNewInfo.filteredData = this.dataSourceNewInfo.data;
        this.dataSourceNewInfo.filter = '';
        this.noDataFound = false;
        this.infoFound = true;
    }

    async onIndustrySelected(event: MatAutocompleteSelectedEvent) {
        this.search = event.option.value;
        this.loading = true;
        this.loadingService.setLoading(this.loading);
        let result: OperationResult = await this.modelService.getRankingInfo(
            event.option.value,
            this.authorizationProperties.accountName,
            this.language
        );
        if (!result.Result) {
            this.workFlow.showMessage(this.variable.warningTitle, result.Message);
        } else {
            this.newInfo = result.Content as NewInfo[];
            this.newInfo.forEach((x) => (x.NrCal = x.SubscriptionToken.caltypes.filter((x) => x.calType === 1)[0].nrCal));
            for (let y = 0; y < this.newInfo.length; y++) {
                for (let i = 0; i < this.newInfo[y].SubscriptionToken.modules.module.length; i++) {
                    if (i === 0) {
                        this.newInfo[y].Fragment = this.newInfo[y].SubscriptionToken.modules.module[i].fragment;
                    } else {
                        this.newInfo[y].Fragment = this.newInfo[y].Fragment.concat(
                            ', ',
                            this.newInfo[y].SubscriptionToken.modules.module[i].fragment
                        );
                    }
                }
            }
            this.dataSourceNewInfo.data = this.newInfo.sort((a, b) => parseInt(a.Ranking) - parseInt(b.Ranking));
            this.dataSourceNewInfo.paginator = this._paginatorSubscriptions;
            this.dataSourceNewInfo.sort = this.subscriptionsSort;
            this.infoFound = true;
            this.rankingListAvailable = [...new Set(this.newInfo.map((x) => x.Ranking).sort())];
            this.dbSizeListAvailable = [...new Set(this.newInfo.map((x) => x.DbSize).sort())];
            this.nrCalAvailable = [...new Set(this.newInfo.map((x) => x.NrCal).sort())];
            this.countriesAvailable = [...new Set(this.newInfo.map((x) => x.Country).sort())];
        }
        this.loading = false;
        this.loadingService.setLoading(this.loading);
    }

    async getOtherInfoOnClick(model: NewInfo) {
        this.loading = true;
        this.loadingService.setLoading(this.loading);
        let result: OperationResult = await this.modelService.getCustomerInfo(model.CustomerId, this.authorizationProperties.accountName);
        if (!result.Result) {
            this.workFlow.showMessage(this.variable.warningTitle, result.Message);
        } else {
            const otherInfo = result.Content as NewInfo;
            this.partnerCode = otherInfo.PartnerCode;
            this.userId = otherInfo.UserId;
            this.existUserID = this.userId ? true : false;
            this.companyName = otherInfo.CompanyName;
            this.note = model.Note;
            this.ranking = model.Ranking;
        }
        if (this.partnerCode) {
            await this.getResellerCompanyName();
        }
        this.loading = false;
        this.loadingService.setLoading(this.loading);
    }

    displayFn(industry: string): string {
        return industry;
    }

    onRowClicked(model: NewInfo) {
        this.expandedElement = this.expandedElement === model ? null : model;
        event.stopPropagation();
        if (this.expandedElement) {
            this.getOtherInfoOnClick(this.expandedElement);
        }
    }

    save(element: NewInfo) {
        let info: CuSubscriptionSlots = new CuSubscriptionSlots();
        info.ranking = parseInt(this.ranking);
        info.subscriptionkey = element.SubscriptionKey;
        info.rankingnote = this.note;
        this.iupService.saveTimeSlotsReactive(info).subscribe(
            (res: OperationResult) => {
                if (!res.Result) {
                    this.workFlow.showMessage(this.variable.warningTitle, res.Message);
                    return;
                }
                this.workFlow.showSnackBar(this.variable.operationSucceeded);
                this.newInfo
                    .filter((x) => x.SubscriptionKey === element.SubscriptionKey)
                    .map((x) => ((x.Ranking = this.ranking), (x.Note = this.note)));
                this.dataSourceNewInfo.data = this.newInfo;
                this.rankingListAvailable = [...new Set(this.newInfo.map((x) => x.Ranking).sort())];
                this.onRowClicked(element);
            },
            (err) => {
                this.workFlow.showMessage(this.variable.warningTitle, err.message);
            }
        );
    }

    public async getResellerCompanyName() {
        let opResult: OperationResult = await this.proxyService.getResellerCompanyName(this.partnerCode);
        // What we need to do if the result is false for not getting the reseller company ?
        this.resellerCompanyName = opResult.Result ? opResult.Content : '';
        this.loading = false;
        this.loadingService.setLoading(this.loading);
    }
}

export class NewInfo {
    CustomerId: string;
    Ranking: string;
    DbSize: string;
    CompanyName: string;
    NrCal: number;
    Country: string;
    PartnerCode: string;
    UserId: string;
    SubscriptionKey: string;
    Description: string;
    SubscriptionToken: SubscriptionToken;
    Fragment: string;
    Note: string;
}

interface Size {
    value: string;
    viewValue: string;
}
